export default {
  fonts: {
    mono: '"SF Mono", "Roboto Mono", Menlo, monospace',
    primaryFont: '"Lato", "sans-serif"',
    headingsFont: '"Quicksand", "sans-serif"'
  }
};
